import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ApiDrop } from "@/generated/models/ApiDrop";
import { faTrophy } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
interface SubmissionPositionProps {
  readonly drop: ApiDrop;
}
export const SubmissionPosition: React.FC<SubmissionPositionProps> = t0 => {
  const $ = _c(11);
  const {
    drop
  } = t0;
  const rank = drop.rank;
  if (!rank) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function getOrdinalSuffix(n) {
      const mod10 = n % 10;
      const mod100 = n % 100;
      if (mod10 === 1 && mod100 !== 11) {
        return "st";
      }
      if (mod10 === 2 && mod100 !== 12) {
        return "nd";
      }
      if (mod10 === 3 && mod100 !== 13) {
        return "rd";
      }
      return "th";
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const getOrdinalSuffix = t1;
  let accentColor;
  let bgColor;
  let rankText;
  bb0: switch (rank) {
    case 1:
      {
        accentColor = "#fbbf24";
        bgColor = "rgba(251,191,36,0.1)";
        rankText = "1st";
        break bb0;
      }
    case 2:
      {
        accentColor = "#CAD5E3";
        bgColor = "rgba(202, 213, 227,0.1)";
        rankText = "2nd";
        break bb0;
      }
    case 3:
      {
        accentColor = "#CD7F32";
        bgColor = "rgba(205,127,50,0.1)";
        rankText = "3rd";
        break bb0;
      }
    default:
      {
        accentColor = "#93939F";
        bgColor = "rgba(147,147,159,0.15)";
        rankText = `${rank}${getOrdinalSuffix(rank)}`;
      }
  }
  const t2 = `1px solid ${accentColor}40`;
  let t3;
  if ($[1] !== accentColor || $[2] !== bgColor || $[3] !== t2) {
    t3 = {
      backgroundColor: bgColor,
      color: accentColor,
      border: t2
    };
    $[1] = accentColor;
    $[2] = bgColor;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <FontAwesomeIcon icon={faTrophy} className="tw-mr-1.5 tw-size-2.5" />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== rankText) {
    t5 = <span className="tw-px-2 tw-py-0.5 tw-text-xs tw-flex tw-items-center">{t4}{rankText}</span>;
    $[6] = rankText;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t5) {
    t6 = <div className="tw-flex tw-items-center tw-rounded-md tw-font-medium tw-whitespace-nowrap tw-w-fit" style={t3}>{t5}</div>;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};